import React from 'react';
import { StatusChip } from '@Components';
import { RiLockLine, RiLockUnlockLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';

import styles from './Title.module.scss';

export const Title = ({ title, isPrivate }: { title: string; isPrivate?: boolean }) => {
  const { t } = useTranslation('account');

  return (
    <div className={styles.titleContainer}>
      <h1 className={styles.title}>{title}</h1>

      <StatusChip
        color="primary"
        className={styles.statusChip}
        label={
          <div className={styles.statusChipLabel}>
            {isPrivate ? (
              <>
                <RiLockLine />
                {t('private')}
              </>
            ) : (
              <>
                <RiLockUnlockLine /> {t('public')}
              </>
            )}
          </div>
        }
      />
    </div>
  );
};
